import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Policies } from '../shared/shared.model';
import { AuthorizePolicyGuard } from './common/guards/authorize-policy.guard';

const routes: Routes = [
  {
    path: 'rankings',
    loadChildren: () => import('./rankings/rankings.module').then(x => x.RankingsModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'rankings' }
  },
  {
    path: 'invites',
    loadChildren: () => import('./invites/invites.module').then(x => x.InvitesModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'invites' }
  },
  {
    path: 'applications',
    loadChildren: () => import('./applications/applications.module').then(x => x.ApplicationsModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'applications' }
  },
  {
    path: 'residents',
    loadChildren: () => import('./residents/residents.module').then(x => x.ResidentsModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'residents' }
  },
  {
    path: 'claims',
    loadChildren: () => import('./claims/claims.module').then(x => x.ClaimsModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'claims' }
  },
  {
    path: 'properties',
    loadChildren: () => import('./properties/properties.module').then(x => x.PropertiesModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'properties' }
  },
  {
    path: 'invite-links',
    loadChildren: () => import('./invite-links/invite-links.module').then(x => x.InviteLinksModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'invites' }
  },
  {
    path: 'managers',
    loadChildren: () => import('./managers/managers.module').then(x => x.ManagersModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'managers' }
  },
  {
    path: 'finances',
    loadChildren: () => import('./finances/finances.module').then(x => x.FinancesModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'finances' }
  },
  {
    path: 'reports',
    loadChildren: () => import('./reports/reports.module').then(x => x.ReportsModule),
    canActivate: [AuthorizePolicyGuard],
    data: { sdDestination: 'finances' }
  },
  {
    path: 'ui-kit',
    loadChildren: () => import('./ui-kit/ui-kit.module').then(x => x.UIKitModule),
    canActivate: [AuthorizePolicyGuard],
    data: { policy: Policies.TECH }
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthorizePolicyGuard],
    data: { sdLanding: true },
    children: []
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SecurityDepositRoutingModule { }
